import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useMemo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';
import { HEADING_SIZES } from '../../constants/styleVariables.js';

var _excluded = ["children", "color", "elemStyle", "elemType", "theme"];
var _templateObject;
var DEFAULT_ELEMENT_TYPE = 'h1';
var DEFAULT_COLOR = 'black';
var isH1 = function isH1(elemStyle, elemType) {
  return elemStyle === 'h1' || elemType === 'h1';
};
var isH2 = function isH2(elemStyle, elemType) {
  return elemStyle === 'h2' || elemType === 'h2';
};
var isSansSerif = function isSansSerif(elemStyle, elemType) {
  return (elemType === 'h1' || elemType === 'h2') && (elemStyle === 'h3' || elemStyle === 'h4' || elemStyle === 'h5' || elemStyle === 'h6');
};
var StyledHeading = styled(DEFAULT_ELEMENT_TYPE)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  * + & {\n    margin-top: 1rem;\n  }\n  letter-spacing: ", "}};\n  line-height: ", "}};\n  line-height: ", "}};\n  font-size: ", "};\n  font-weight: ", "};\n  font-family: ", "};\n  color: ", ";\n"])), function (_ref) {
  var _ref$elemStyle = _ref.elemStyle,
    elemStyle = _ref$elemStyle === void 0 ? DEFAULT_ELEMENT_TYPE : _ref$elemStyle;
  return HEADING_SIZES[elemStyle].letterSpacing;
}, function (_ref2) {
  var _ref2$elemStyle = _ref2.elemStyle,
    elemStyle = _ref2$elemStyle === void 0 ? DEFAULT_ELEMENT_TYPE : _ref2$elemStyle;
  return HEADING_SIZES[elemStyle].lineHeight;
}, function (_ref3) {
  var _ref3$elemStyle = _ref3.elemStyle,
    elemStyle = _ref3$elemStyle === void 0 ? DEFAULT_ELEMENT_TYPE : _ref3$elemStyle;
  return HEADING_SIZES[elemStyle].lineSpacing;
}, function (_ref4) {
  var _ref4$elemStyle = _ref4.elemStyle,
    elemStyle = _ref4$elemStyle === void 0 ? DEFAULT_ELEMENT_TYPE : _ref4$elemStyle;
  return HEADING_SIZES[elemStyle].base;
}, function (_ref5) {
  var _ref5$elemStyle = _ref5.elemStyle,
    elemStyle = _ref5$elemStyle === void 0 ? DEFAULT_ELEMENT_TYPE : _ref5$elemStyle;
  return HEADING_SIZES[elemStyle].fontWeight;
}, function (_ref6) {
  var _ref6$elemStyle = _ref6.elemStyle,
    elemStyle = _ref6$elemStyle === void 0 ? DEFAULT_ELEMENT_TYPE : _ref6$elemStyle,
    _ref6$elemType = _ref6.elemType,
    elemType = _ref6$elemType === void 0 ? DEFAULT_ELEMENT_TYPE : _ref6$elemType,
    theme = _ref6.theme;
  return isSansSerif(elemStyle, elemType) && theme.fontFamily || (isH1(elemStyle, elemType) || isH2(elemStyle, elemType)) && theme.headings.fontFamily;
}, function (_ref7) {
  var _ref7$color = _ref7.color,
    color = _ref7$color === void 0 ? DEFAULT_COLOR : _ref7$color,
    theme = _ref7.theme;
  return theme.palette[color];
});
var Heading = function Heading(_ref8) {
  var children = _ref8.children,
    _ref8$color = _ref8.color,
    color = _ref8$color === void 0 ? DEFAULT_COLOR : _ref8$color,
    elemStyle = _ref8.elemStyle,
    _ref8$elemType = _ref8.elemType,
    elemType = _ref8$elemType === void 0 ? DEFAULT_ELEMENT_TYPE : _ref8$elemType,
    _ref8$theme = _ref8.theme,
    theme = _ref8$theme === void 0 ? themes["default"] : _ref8$theme,
    rest = _objectWithoutProperties(_ref8, _excluded);
  var Element = useMemo(function () {
    return StyledHeading.withComponent(elemType);
  }, [elemType, elemStyle]);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: className,
    color: color,
    elemStyle: !!elemStyle ? elemStyle : elemType,
    elemType: elemType,
    style: style,
    theme: theme
  }), children);
};
var _Heading = withDefaultTheme(/*#__PURE__*/memo(Heading));

export default _Heading;
export { Heading };
